import { useState } from "react";
import { RadioGroup } from "@headlessui/react";
import I18n from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface SelectFilterProps {
  onChange: (value: string) => void;
  options: { label: string }[];
}

export const SelectFilter = ({ options = [], onChange }: SelectFilterProps) => {
  const [value, setValue] = useState(options[0]);

  const handleSubmit = () => {
    // @ts-expect-error - somehow we pass options as an object to the component, but when onChange triggers it becomes string
    // Usage: mobile view online filter
    onChange(value);
  };

  return (
    <>
      <RadioGroup value={value} onChange={setValue}>
        {options.map(option => (
          <RadioGroup.Option
            value={option.label}
            key={option.label}
            className="relative mt-3 flex cursor-pointer focus:outline-none"
          >
            {({ checked }) => (
              <>
                <span
                  className={`mt-0.5 flex size-4 cursor-pointer items-center justify-center rounded-full border ${
                    checked
                      ? "border-transparent bg-indigo-600"
                      : "border-gray-300 bg-white"
                  }`}
                  aria-hidden="true"
                >
                  <span className="size-1.5 rounded-full bg-white" />
                </span>
                <div className="ml-3 flex flex-col">
                  <RadioGroup.Label
                    as="span"
                    className="text-dark block text-sm font-medium"
                  >
                    {option.label}
                  </RadioGroup.Label>
                </div>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </RadioGroup>
      <div className="mt-3">
        <Button variant="primary" onClick={handleSubmit}>
          {I18n.t("members_directory.header.search.apply_filter")}
        </Button>
      </div>
    </>
  );
};
